module.exports = __webpack_public_path__ + "img/商城供应商.57c62a43.png";